import React from 'react';
import styled from 'styled-components';
import { rem } from '@packages/ui/tokens';
import type { FormColumnGroupNode } from '../../types/layout';
import { FormFieldsRenderer } from '../fields/FormFieldsRenderer';

interface ColumnGroupRendererProps {
  node: FormColumnGroupNode;
  namePrefix?: string;
}

const GroupGrid = styled.div<{ $count: number }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(24)};
  width: 100%;

  @media (min-width: 640px) {
    grid-template-columns: repeat(${({ $count }) => $count}, 1fr);
  }

  &:not(:first-child) {
    margin-top: ${rem(32)};
  }
`;

const GroupColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  --matrix-row-gap: ${rem(4)};
`;

const GroupTitle = styled.div`
  font-family: var(--ui-font-heading, var(--ui-font-sans, 'HK Grotesk', sans-serif));
  font-size: ${rem(20)};
  font-weight: 400;
  line-height: ${rem(24)};
  color: #595959;
  margin-bottom: 0;
`;

export const FormColumnGroupRenderer = React.memo(function FormColumnGroupRenderer({
  node,
  namePrefix,
}: ColumnGroupRendererProps): React.ReactElement {
  return (
    <GroupGrid $count={node.groups.length} data-form-column-group={node.semanticId}>
      {node.groups.map((group, idx) => (
        <GroupColumn key={idx}>
          {group.title != null && group.title !== '' && (
            <GroupTitle>{group.title}</GroupTitle>
          )}
          <FormFieldsRenderer
            node={{ type: 'fields', fields: group.fields }}
            namePrefix={namePrefix}
          />
        </GroupColumn>
      ))}
    </GroupGrid>
  );
});
